import { fDateYMD } from '../../../utils/formatTime';
import { buildQuery } from '../../../utils/query';

// One query builder for the invoices list, so paging and filtering cannot send
// different URLs. An invoice carries two states and the table shows both:
// `status` is whether it has been paid, `approval_status` whether loss control
// has signed it off.
const invoiceListQuery = ({
  page = 1,
  rowsPerPage = 10,
  locationId,
  invoicePaymentStatus,
  approvalStatus,
  serviceProvider,
  startDate,
  endDate,
  searchTerm,
} = {}) =>
  buildQuery({
    page,
    page_size: rowsPerPage,
    location_id: locationId,
    status: invoicePaymentStatus,
    approval_status: approvalStatus,
    service_provider: serviceProvider,
    start_date: startDate ? fDateYMD(startDate) : '',
    end_date: endDate ? fDateYMD(endDate) : '',
    search_term: searchTerm,
  });

export default {
  GET_INVOICES: (params) => `payments/invoices/${invoiceListQuery(params)}`,
  GET_ONSITE_MAINTENANCE_RECORDS: ({ page = 1, rowsPerPage = 10 }) =>
    `maintenance/onsite?page=${page}&page_size=${rowsPerPage}`,
  GET_OFFSITE_MAINTENANCE_RECORDS: ({ page = 1, rowsPerPage = 10 }) =>
    `maintenance/offsite?page=${page}&page_size=${rowsPerPage}`,
  GET_ASSET_MAINTENANCE_RECORDS: ({ id, page = 1, rowsPerPage = 10 }) =>
    `maintenance/?asset_id=${id}&page=${page}&page_size=${rowsPerPage}`,
  GET_MAINTENANCE_RECORD: (id) => `maintenance/${id}`,
  TRANSFER_ASSET: (id) => `assets/${id}/transfer/`,
  CREATE_MAINTENANCE_RECORD: 'maintenance/',
  CREATE_REPAIR_RECORD: 'maintenance/repairs/',
  UPDATE_REPAIR_RECORD: (id) => `maintenance/repairs/${id}/`,
  GET_REPAIR_DETAIL: (id) => `maintenance/repairs/?maintenance_id=${id}`,
  UPDATE_STATUS: (id) => `maintenance/${id}/status`,
  APPROVE_INVOICE: (id) => `payments/invoices/${id}/approval/`,
  DECLINE_MAINTENANCE: (id) => `maintenance/${id}/decline-maintenance`,
  RETURN_REQUEST: (id) => `maintenance/${id}/return-request/`,
  ACCEPT_RETURN_REQUEST: (id) => `maintenance/${id}/return-request/accept/`,
  DECLINE_RETURN_REQUEST: (id) => `maintenance/${id}/return-request/decline/`,
  SP_REPAIR_ACCEPTANCE: (id) => `maintenance/${id}/service-provider/accept/`,
  SP_REPAIR_DECLINE: (id) => `maintenance/${id}/service-provider/decline/`,
  DELETE_ASSET: (id) => `assets/${id}/delete/`,
};
